var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "youtube",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_26859",
    "data-name": "Path 26859",
    d: "M19.016,67.393H4.984A4.987,4.987,0,0,0,0,72.382V79.4a4.987,4.987,0,0,0,4.984,4.989H19.016A4.987,4.987,0,0,0,24,79.4V72.382A4.987,4.987,0,0,0,19.016,67.393Zm-3.371,8.842L9.082,79.368A.263.263,0,0,1,8.7,79.13V72.668a.263.263,0,0,1,.383-.235l6.563,3.329A.264.264,0,0,1,15.645,76.235Z",
    transform: "translate(0 -67.393)",
    fill: "#f61c0d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e55c1966bef9df150e2a419de9451e0d.svg";
export { ForwardRef as ReactComponent };